import base from './base.repository';

export default {
    ...base,
    loadSafetyRecommendations(filters, page){
        const params = {...filters, page: page};
        this.get(`safety-recommendations${this.querify(params)}`);
        return this;
    },
    loadSafetyRecommendationsAuthors(){
        this.get(`safety-recommendations/authors`);
        return this;
    },
    saveSafetyRecommendation(SafetyRecommendation) {
        this.post(`safety-recommendations`, SafetyRecommendation);
        return this;
    },
    updateSafetyRecommendation(SafetyRecommendation, id) {
        this.put('safety-recommendations/' + id, SafetyRecommendation);
        return this;
    },
    deleteSafetyRecommendation(id){
        this.delete('safety-recommendations/'+ id);
        return this;
    },
    saveSafetyRecommendationPhotos(photos){
        this.post(`safety-recommendations/save-photos`, photos);
        return this;
    },
}